// Product price × quantity: when the shopper changes the quantity in a product form, every price
// shown in that form's [data-product-price] (current and compare-at) is multiplied, so the
// displayed price is the total for that quantity. Formatting copies the store's money format
// from data-money-sample, which is 1234567.89 rendered through the Liquid money filter.
// Delegated from the document so it also works inside the quick-add window.
if (!window.__vantaraPriceTotal) {
  window.__vantaraPriceTotal = true;

  const originals = new WeakMap();
  const SAMPLE_DIGITS = '123456789';

  function moneyParts(sample) {
    const match = sample.match(/\d[\d.,'\s\u00a0]*\d/);
    if (!match) return null;
    const numeric = match[0];
    const hasDecimals = /[.,]\d{2}$/.test(numeric) && numeric.replace(/\D/g, '') === SAMPLE_DIGITS;
    const decimal = hasDecimals ? numeric.charAt(numeric.length - 3) : '';
    const body = hasDecimals ? numeric.slice(0, -3) : numeric;
    const thousands = (body.match(/[^\d]/) || [''])[0];
    return { prefix: sample.slice(0, match.index), suffix: sample.slice(match.index + numeric.length), decimal, thousands };
  }

  function parseCents(text, parts) {
    const match = text.match(/\d[\d.,'\s\u00a0]*\d|\d/);
    if (!match) return null;
    const digits = match[0].replace(/\D/g, '');
    if (!digits) return null;
    return { cents: parts.decimal ? Number(digits) : Number(digits) * 100, match };
  }

  function formatCents(cents, parts) {
    const whole = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, parts.thousands);
    return parts.decimal ? `${whole}${parts.decimal}${String(cents % 100).padStart(2, '0')}` : whole;
  }

  function update(form) {
    const priceRoot = form.querySelector('[data-product-price]');
    const sample = priceRoot?.dataset.moneySample;
    if (!priceRoot || !sample) return;
    const parts = moneyParts(sample);
    if (!parts) return;

    const quantity = Math.max(1, Number(form.querySelector('input[name="quantity"]')?.value) || 1);
    const walker = document.createTreeWalker(priceRoot, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      if (!originals.has(node)) originals.set(node, node.textContent);
      const original = originals.get(node);
      if (!/\d/.test(original) || /%/.test(original)) continue;
      const parsed = parseCents(original, parts);
      if (!parsed) continue;
      const total = formatCents(parsed.cents * quantity, parts);
      node.textContent = original.slice(0, parsed.match.index) + total + original.slice(parsed.match.index + parsed.match[0].length);
    }
  }

  const handle = (event) => {
    if (!(event.target instanceof Element)) return;
    const form = event.target.closest('form');
    if (form && form.querySelector('[data-product-price]')) update(form);
  };

  document.addEventListener('s-quantity:change', handle);
  document.addEventListener('input', handle);
  document.addEventListener('change', handle);
}
